import createActions from 'utils/redux/createActions'
import env from 'utils/env'
import domain from 'utils/domain'
import PouchDB from 'pouchdb-browser'

export default createActions([
	'LOGIN'
  , 'LOGIN_FAIL'
  , 'LOGIN_OK'
  , {
  		type: 'LOGOUT'
	  , act: function() {
	  		new PouchDB(`landlord-${env}-attachments`).destroy()
			new PouchDB(`landlord-${env}`).destroy()
			.then(() => localStorage.clear())
			.then(() => fetch(`https://${domain}/${env}/_session`, {
				method: 'DELETE'
			  , credentials: 'include'
			}))
			.then(() => global.location.reload())
			.catch(() => global.location.reload())
			return { type: this.type }
		}
	}
])



// WEBPACK FOOTER //
// ./src/actions/sessionActions.js